export default __webpack_public_path__ + "static/media/revenue_goal.aa5d58ac.svg";